import _default from './Form';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/collections/Form/index.js
// module id = 640
// module chunks = 0